import { animate, state, style, transition, trigger } from "@angular/animations";

export const fadeIn = (duration: string) =>
    trigger("fadeIn", [
        state("void", style({ opacity: 0 })),
        state("*", style({ opacity: 1 })),
        transition("void => *", animate(duration)),
        transition("* => void", animate(duration))
    ]);
